/* @flow */
import Button from 'components/Button.jsx';
import Coin from 'components/Coin.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Device from 'entities/Device';
import DeviceActions from 'actions/DeviceActions';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import ResentConfirmationEmail from 'settings/components/ResentConfirmationEmail.jsx';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/UserEmailDevice.scss';

const UserEmailDevice = React.createClass({
  propTypes: {
    device: React.PropTypes.instanceOf(Device).isRequired,
    btnDisabled: React.PropTypes.bool,
  },

  getInitialState() {
    return {
      isHovering: false,
    };
  },

  onRemoveSuccess(device: Device) {
    ToastActions.showSuccessToast(`${device.getLabel()} removed`);
  },

  onRemoveError() {
    ToastActions.showDefaultErrorToast();
  },

  removeEmail() {
    return DeviceActions.deleteEmailDevice(this.props.device).then(
      this.onRemoveSuccess,
      this.onRemoveError,
    );
  },

  renderConfirmDialog() {
    return (
      <ConfirmDialog
        eventScreenName="UserEmailDevice"
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        size="xsmall"
        glyph="caution"
        glyphColor="lava"
        title={`Remove ${this.props.device.getLabel()}?`}
        subtext={`This email address will no longer be associated with your account. You can always
          add it again!`}
        preConfirmPromise={this.removeEmail}
      />
    );
  },

  renderHoverContent() {
    return (
      <ModalTrigger modal={this.renderConfirmDialog()}>
        <Button
          className="UserEmailDevice-Row-removeBtn"
          level="secondary"
          size="xsmall"
          color="lava"
          tooltip={this.props.btnDisabled ? `Want to stay in touch? Add another email address
            before removing your primary email address` : ''}
          tooltipAlignment="right"
          tooltipPlacement="bottom"
          disabled={this.props.btnDisabled}
          eventElementName="UserEmailDevice-Row-removeBtn">
          Remove
        </Button>
      </ModalTrigger>
    );
  },

  renderVerified() {
    return (
      <Coin color="shamrock" size="xxsmall">
        <Glyph name="check" color="white" solo />
      </Coin>
    );
  },

  renderNotVerified() {
    return (
      <span>
        <Coin border="flame" size="xxsmall">
          <Glyph name="explanation" color="flame" solo />
        </Coin>
        <div className="UserEmailDevice-VerificationText">
          Pending confirmation. {' '}
          <ResentConfirmationEmail
            className="UserEmailDevice-ResendConfirmation"
            email={this.props.device}>
            Resend email
          </ResentConfirmationEmail>
        </div>
      </span>
    );
  },

  render() {
    const { device } = this.props;
    return (
      <div
        key={device.id}
        className="UserEmailDevice"
        onMouseEnter={() => this.setState({ isHovering: true })}
        onMouseLeave={() => this.setState({ isHovering: false })}>
        <FlexibleBlock flex="left">
          <div className="UserEmailDevice-label">
            <Text
              color={device.isVerified() ? 'pitch' : 'thunder'}
              weight="semibold">
              {device.getLabel()}
              {' '}
              {device.isVerified() ? this.renderVerified() : this.renderNotVerified()}
            </Text>
          </div>
          {this.state.isHovering && this.renderHoverContent()}
        </FlexibleBlock>
      </div>
    );
  },
});

export default UserEmailDevice;



// WEBPACK FOOTER //
// ./src/settings/components/UserEmailDevice.jsx